import { render, staticRenderFns } from "./PaymentAnnouncement06-05-2026.vue?vue&type=template&id=9ed10b32"
import script from "./PaymentAnnouncement06-05-2026.vue?vue&type=script&lang=js"
export * from "./PaymentAnnouncement06-05-2026.vue?vue&type=script&lang=js"
import style0 from "./PaymentAnnouncement06-05-2026.vue?vue&type=style&index=0&id=9ed10b32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports